import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
	constructor(
		private router: Router
	) { }

	public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		console.log('into interceptor')
		const headers = req.clone(
			{
				
				headers: req.headers
					.set('Access-Control-Allow-Origin', '*')
					.set('Access-Control-Allow-Methods', 'GET, POST, OPTIONS, PUT, DELETE')
					.set('Access-Control-Request-Method', '*')
					.set('ccess-Control-Allow-Headers', 'Authorization, X-API-KEY, Origin, X-Requested-With, Content-Type, Accept, Access-Control-Allow-Request-Method')
					.set('Allow', 'GET, POST, OPTIONS, PUT, DELETE')
					.set('Content-Type', 'application/json; charset=utf-8')
					.set('Accept', 'application/json')
					.set('Access-Control-Allow-Credentials', 'false')
					

			}

		);

		console.log(headers)
		return next.handle(headers).pipe(
      catchError((err: HttpErrorResponse) => {

		console.log("error detectado")
        return throwError( err );

      })
    );
	}
	/*
		getData(): Observable<any> {
		return from(
		  fetch(
			'http://xxxxx', // the url you are trying to access
			{
			  headers: {
				'Content-Type': 'application/json',
			  },
			  method: 'GET', // GET, POST, PUT, DELETE
			  mode: 'no-cors' // the most important option
			}
		  ));
	  }*/
}